import { view } from "@/mega-ui/helpers/function"
import { checkContractGuard } from "@/helpers/routerHelpers"

export const orders = {
    path: '/orders',
    name: 'orders',
    children: [
        {
            path: '',
            name: 'order-follow',
            beforeEnter: [ checkContractGuard ],
            meta: {
                withAuth: true,
                withProducts: true,
            },
            component: () => view('orders/OrdersMainView')
        },
    ]
}